/**
 * BackupRuns — Batch #14.338 : historique des sauvegardes / restaurations (statut, taille, durée, erreur).
 */
const TRIG = { auto: "Automatique", manual: "Manuelle", prerestore: "Sécurité", restore: "Restauration", dossier: "Dossier", "restore-dossier": "Restauration dossier" };
const fmt = (iso) => (iso ? new Date(iso).toLocaleString("fr-CA", { dateStyle: "short", timeStyle: "short" }) : "—");
const mb = (n) => (n ? `${(n / 1048576).toFixed(1)} Mo` : "—");

export default function BackupRuns({ runs }) {
  if (!runs.length) return <div className="text-xs text-slate-500" data-testid="backup-runs-empty">Aucune sauvegarde exécutée pour l'instant.</div>;
  return (
    <div className="bg-white border rounded-xl overflow-x-auto" data-testid="backup-runs">
      <table className="w-full text-sm">
        <thead><tr className="text-left text-xs text-slate-500 border-b"><th className="px-3 py-1.5">Quand</th><th className="px-3 py-1.5">Type</th><th className="px-3 py-1.5">Statut</th><th className="px-3 py-1.5">Fichier</th><th className="px-3 py-1.5 text-right">Docs</th><th className="px-3 py-1.5 text-right">Taille</th><th className="px-3 py-1.5 text-right">Durée</th></tr></thead>
        <tbody>
          {runs.map((r) => (
            <tr key={r.id} className="border-b last:border-0" data-testid={`backup-run-${r.id}`}>
              <td className="px-3 py-1.5 text-xs text-slate-600">{fmt(r.started_at)}</td>
              <td className="px-3 py-1.5 text-xs">{TRIG[r.trigger] || r.trigger}{r.master_name && <span className="block text-[10px] text-slate-500">{r.master_name}</span>}</td>
              <td className="px-3 py-1.5 text-xs">
                {r.status === "ok" && <span className="px-1.5 rounded bg-emerald-100 text-emerald-800">Réussie</span>}
                {r.status === "running" && <span className="px-1.5 rounded bg-sky-100 text-sky-800">En cours</span>}
                {r.status === "error" && <span className="px-1.5 rounded bg-rose-100 text-rose-800" title={r.error}>Échec</span>}
                {r.error && <div className="text-[11px] text-rose-700 max-w-xs truncate" title={r.error}>{r.error}</div>}
              </td>
              <td className="px-3 py-1.5 text-xs font-mono text-slate-600">{r.name || "—"}{r.safety_backup && <div className="text-[11px] text-amber-700">sécurité : {r.safety_backup}</div>}</td>
              <td className="px-3 py-1.5 text-xs text-right tabular-nums">{r.documents ?? "—"}</td>
              <td className="px-3 py-1.5 text-xs text-right tabular-nums">{mb(r.size)}</td>
              <td className="px-3 py-1.5 text-xs text-right tabular-nums">{r.duration_s ? `${r.duration_s} s` : "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
